export default __webpack_public_path__ + "static/media/gb-background.60724dd2.jpg";